import { useEffect, useState, useContext } from "react";
import axios from "axios";
import Carousel from "react-bootstrap/Carousel";
import "./HomeCarousel.css";
import { CompanyContext } from "../contexts/CompanyContext";
import SearchForm from "../pages/SearchForm";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const HomeCarousel = ({ onSearch, isSearching }) => {
  const [carouselItems, setCarouselItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { primaryColor, secondaryColor, searchFormPosition } =
    useContext(CompanyContext);

  useEffect(() => {
    const getCarousel = async () => {
      try {
        const res = await axios.post(
          "https://hrms-api.apisod.ai/api/carousel-list",
          {}
        );
        // console.log("Carousel data", res.data.data);
        const items = res.data.data || [];
        // Preload images
        items.forEach((item) => {
          const img = new Image();
          img.src = item.image;
        });
        setCarouselItems(items);
        setLoading(false);
      } catch (e) {
        console.error("Error fetching carousel data", e);
        setLoading(false);
      }
    };
    getCarousel();
  }, []);

  return (
    <>
      {carouselItems.length === 1 ? (
        <div style={{ position: "relative" }}>
          {searchFormPosition === "over" && (
            <SearchForm
              position={searchFormPosition}
              onSearch={onSearch}
              isSearching={isSearching}
            />
          )}
          <div className="carousel-single-item">
            {loading ? (
              <Skeleton height={420} />
            ) : (
              <img
                className="d-block w-100"
                src={carouselItems[0].image}
                alt={carouselItems[0].title}
                style={{ height: "420px", objectFit: "cover" }}
              />
            )}
            <div className="carousel-single-caption">
              {/* <h3>{carouselItems[0].title}</h3>
              <p>{carouselItems[0].description}</p> */}
            </div>
          </div>
        </div>
      ) : (
        <div style={{ position: "relative" }}>
          {searchFormPosition === "over" && (
            <SearchForm
              position={searchFormPosition}
              onSearch={onSearch}
              isSearching={isSearching}
            />
          )}

          <Carousel fade interval={3000}>
            {loading ? (
              <Skeleton height={450} />
            ) : (
              carouselItems.map((item, index) => (
                <Carousel.Item key={index}>
                  <img
                    className="d-block w-100"
                    src={item.image}
                    alt={`Slide ${index + 1}`}
                    style={{ height: "420px", objectFit: "cover" }}
                  />
                  {/* <Carousel.Caption>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </Carousel.Caption> */}
                </Carousel.Item>
              ))
            )}
          </Carousel>
        </div>
      )}
    </>
  );
};

export default HomeCarousel;
